import styled from "styled-components";

export const Wrapper = styled.div`
  display: none;
  gap: 4px;
  flex: 1;
  height: 70svh;
  cursor: pointer;

  @media(min-width: ${({theme}) => theme.breakpoints.desktop}){
    display: flex;
  }
`;

const PhotoWrapper = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MainPhotoWrapper = styled(PhotoWrapper)`
  width: 50%;
  height: 100%;
`;

export const Photo = styled.img`
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
`;

export const MultiPhotoWrapper = styled.div`
  display: grid;
  width: 50%;
  grid-template-columns: 50% 50%;
  gap: 4px;
  height: 100%;
`;

export const SmallPhotoWrapper = styled(PhotoWrapper)`
  width: 100%;
  height: 100%;
  &:last-child {
    position: relative;
    > img {
      filter: blur(3px);
    }
  }
`;

export const PhotoFilter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.palette.greyscale.grey50};
  background-color: rgba(0, 0, 0, 0.5);
  font-size: ${24 / 16}rem;
  font-weight: bold;
  z-index: 1;
`;

export const EmptyPhotoContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.palette.greyscale.grey50};
`;